import OwnerCard from "./owner-card";
import { Box, Button, CircularProgress, Grid } from "@mui/material";
import Header from "./Header";
import ErrorFallback from "../../common/ErrorFallback";
import EditClientDetailsModal from "./update-client/EditClientDetails";
import ReplaceUserForClientModal from "./update-client/ReplaceUserForClient";
import Alerts from "./Alerts";
import DetailsCard from "./details-card";
import ClientDetailsProvider from "../context/clientDetailsProvider";
import InvestmentsCard from "./investment-card";
import { useNavigate, useParams } from "react-router";
import { useClientDetails } from "../context/clientDetailsContext";

function ClientDetailsWrapper() {
  const { id: clientId } = useParams<{ id: string }>();

  if (!clientId) {
    throw Error("Client ID is required");
  }

  return (
    <ClientDetailsProvider clientId={clientId}>
      <ClientDetails clientId={clientId} />
    </ClientDetailsProvider>
  );
}

function ClientDetails({ clientId }: { clientId: string }) {
  const {
    client: { loading, error, details },
  } = useClientDetails();

  const navigate = useNavigate();

  if (loading) {
    return (
      <Box
        data-testid="client-details-loading-indicator"
        sx={{
          height: "80vh",
          display: "flex",
          direction: "column",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <>
        <ErrorFallback error={error} />
        <Button variant="contained" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </>
    );
  }

  if (details) {
    return (
      <Box sx={{ margin: 4 }}>
        <Alerts />
        <EditClientDetailsModal />
        <ReplaceUserForClientModal />
        <Grid container spacing={2} data-testid="client-details-container">
          <Header />

          <Grid container size={12} spacing={2}>
            <Grid flex={8} data-testid="client-details-page-content-container">
              <DetailsCard />
            </Grid>
            <Grid
              flex={4}
              data-testid="client-owner-details-page-content-container"
            >
              <OwnerCard />
            </Grid>
          </Grid>

          <Grid
            size={8}
            spacing={2}
            data-testid="client-investment-details-page-content-container"
          >
            <InvestmentsCard />
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <>
      <ErrorFallback
        error={{ message: `An issue occurred with client: ${clientId}` }}
      />
      <Button variant="contained" onClick={() => navigate(-1)}>
        Go Back
      </Button>
    </>
  );
}

export default ClientDetailsWrapper;
